<template>
  <div class="dropdown">
    <div @click="toggleDropdown" class="dropdown-text">
      Choose a diagram
    </div>
    <div v-if="dropdownOpen" class="dropdown-content" id="dropdown">
      <label v-for="chart in chartOptions" :key="chart.value">
        <input
          type="radio"
          :value="chart.value"
          v-model="selectedChart"
        />
        {{ chart.label }}
      </label>
    </div>
  </div>



  <div v-if="selectedChart === 'tyre'" class="diagcont">
    <GoogleChart/>
    <DiagramChart label="Front right" data="FR_tyre" />
    <DiagramChart label="Front left" data="FL_tyre" />
    <DiagramChart label="Rear right" data="RR_tyre" />
    <DiagramChart label="Rear left" data="RL_tyre" />
  </div>

  <div v-if="selectedChart === 'steering'" class="diagcont">
    <DiagramChart label="Steering Angle" data="SteeringAngle" />
    <DiagramChart label="Throttle Position" data="ThrottlePosition" />
    <DiagramChart label="Front Brake Pressure" data="FrontBrakePressure" />
    <DiagramChart label="Brake Power" data="BrakePower" />
  </div>

  <div v-if="selectedChart === 'engine'" class="diagcont">
    <DiagramChart label="Battery Voltage" data="BatteryVolts" />
    <DiagramChart label="Coolant Temp" data="CoolantTemp" />
    <DiagramChart label="DRS" data="DRS" />
  </div>

  <div v-if="selectedChart === 'speed'" class="diagcont">
    <DiagramChart label="Acceleration Forward" data="AccelerationForward" />
    <DiagramChart label="Vehicle Speed" data="Vehicle_speed" />
  </div>

  <div v-if="selectedChart === 'motor'" class="diagcont">
    <DiagramChart label="Motor Temperature" data="MotorTemperature" />
    <DiagramChart label="Motor Torque" data="MotorTorque" />
  </div>

</template>

<script setup>
import { ref } from 'vue';
import DiagramChart from '@/components/DiagramChart.vue';

const dropdownOpen = ref(false);

const Options = [
  { value: 'steering', label: 'Steering' },
  { value: 'tyre', label: 'Tyre' },
  { value: 'engine', label: 'Engine' },
  { value: 'motor', label: 'Motor' },
  { value: 'speed', label: 'Speed' }
];

const chartOptions = Options.sort((a, b) => a.label.localeCompare(b.label));
const selectedChart = ref(chartOptions[0].value);


const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value;
};
</script>

